import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { MedicalOrderScannZoomDialogComponent } from '../medical-order-scann-zoom/medical-order-scann-zoom-dialog.component';
import { PreviusStudiesDigitizedService } from '../../../services/previous-studies-digitized/previous-studies-digitized.service';
import { ConfirmDialogService } from '../../../services/confirm-dialog.service';



class IdImage64 {
  constructor(id: number) {
    this.id = id;
  }
  id: number;
  image64: string;
}

@Component({
  selector: 'app-previous-studies-digitized-show-dialog',
  templateUrl: './previous-studies-digitized-show-dialog.component.html',
  styleUrls: ['./previous-studies-digitized-show-dialog.component.css']
})
export class PreviousStudiesDigitizedShowDialogComponent implements OnInit {

  hideElement = true; 
  deleting: boolean;
  loading: boolean;
  loadingImage: boolean; 
  index: number; 
  idsImage64: IdImage64[] = [];

  constructor(
      public dialogRef: MatDialogRef<PreviousStudiesDigitizedShowDialogComponent>
    , private notificationToastService: NotificationToastService  
    , public dialog: MatDialog 
    , private confirmDialogService: ConfirmDialogService
    , private domSanitizer: DomSanitizer
    , private psdService: PreviusStudiesDigitizedService
    , @Inject(MAT_DIALOG_DATA) public data: number) {
     this.index = -1;
  }

  async ngOnInit() {
    try {
      this.loading = true;
      const ids = await this.psdService
        .getPreviousStudiesDigitizedIdsByMedicalAppointmentId(this.data);
      if ( ids != null ){
        this.idsImage64 = ids.map(id => new IdImage64(id));
        if (this.idsImage64.length > 0)
          this.index = 0;
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Orden escaneos');
    } finally {
      this.loading = false;
    }
  }
 
  onNoClick(): void {
    this.dialogRef.close(null);
  }

  async remove() {
    try {
      const confirm = this.confirmDialogService
        .confirm('Estudios anteriores', 'Seguro que desea eliminar?', 'Sí', 'No').toPromise();

      if (this.idsImage64.length > 0 && await confirm) {
        this.deleting = true;
        const image =  this.idsImage64[this.index] ;
        await this.psdService.deletePreviousStudiesDigitized(image.id);
        this.idsImage64.splice(this.index, 1); 
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Estudios anteriores');
    } finally {
      this.deleting = false;
    }
  }
  

  getDisplayIndex(): string {
    const total = this.idsImage64.length;
    const actual = this.index + 1;
    return actual + ' de ' + total;
  }
  

  getSafeUrl(): SafeUrl {
    if (this.idsImage64.length > 0 && this.index > -1) {
      this.loadingImage = true;
      const image = this.idsImage64[this.index];
      if (!image.image64) {
        this.psdService.getPreviousStudiesDigitizedFileById(image.id)
        .then((complete) => {
          image.image64 = 'data:image/jpg;base64,' + complete;
          this.loadingImage = false;
          return  this.getSafeUrlIfNeed(image.image64);
        });
      } else {
        this.loadingImage = false;
        return  this.getSafeUrlIfNeed(image.image64);
      }
    } else {
      this.loadingImage = false;
      return null;
    }
  }

  getSafeUrlIfNeed(image64: string): SafeUrl {
    return this.domSanitizer.bypassSecurityTrustUrl(image64); 
  }

  existsImage(): boolean {
    return this.idsImage64.length > 0;
  }

  goBack(): void {
    if (this.index > 0) {
      this.index = this.index - 1;
    }
  }

  next(): void {
    if (this.idsImage64.length - 1 > this.index) {
      this.index = this.index + 1;
    }
  }

  zoom(): void {
    this.dialog.open(MedicalOrderScannZoomDialogComponent, {
      width: '95%',
      height: '95%',
      data: {
        url: this.getSafeUrlIfNeed(this.idsImage64[this.index].image64),
        base64: this.idsImage64[this.index].image64
      }
    });
  }
 
}
